<script>
import ListEndosso from '@/views/lists/ListEndosso.vue';
import service from '@/services/endosso';

export default {
  name: 'EndossoView',
  components: {
    ListEndosso,
  },
  data() {
    return {};
  },
  methods: {
    async baixarRelatorio() {
      service
        .baixarRelatorioEndosso()
        .then((res) => {
          if (res) {
            this.$vs.notify({
              title: 'Sucesso',
              text: 'Relatório gerado com sucesso',
              color: 'success',
              position: 'top-center',
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Erro',
            text: 'Erro ao gerar relatório',
            color: 'danger',
            position: 'top-center',
          });
        });
    },
  },
};
</script>

<template>
  <div>
    <vs-card>
      <div class="flex justify-between">
        <h2>Relatório de Endosso</h2>
        <vs-button color="primary" @click="baixarRelatorio">
          <div class="flex items-center gap-2">
            <vs-icon icon="save" size="15px" />
            Baixar Relatório
          </div>
        </vs-button>
      </div>
      <ListEndosso />
    </vs-card>
  </div>
</template>

<style scoped></style>
